import { useCallback, useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import CloseIcon from "@mui/icons-material/Close"
import {
  Avatar,
  Backdrop,
  Box,
  Button,
  DialogTitle,
  IconButton,
  Alert,
  Grid,
  Tab,
  Tabs,
  Select,
  MenuItem,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from "@mui/material"
import { useAppSelector, useAppDispatch } from "@/core/app/hooks"
import { RootState } from "@/core/app/store"
import { ULoading, UText } from "@/components/index"
import { StageNumber } from "./StageNumber"
import { OrderLabel } from "./OrderLabel"
import { UndercutFill } from "./UndercutFill"
import { TrimLine } from "./TrimLine"
import { PrintOthers } from "./PrintOthers"
import SelectStage from "./SelectStage"
import FormControlLabel from "@mui/material/FormControlLabel"
import Checkbox from "@mui/material/Checkbox"
import { caseManagement, stagingManager, wasmModule } from "@/gluelayer"
import {
  clearPrintedStageInPrint,
  setIsPrintAsDPA,
  setOpenLabelPreview,
  setOpenReviewPrint,
  setOpenStlPrint,
  setOpenTrimPreview,
  setOpenUndercutPreview,
  setPrintedStageInPrint,
  setSelectStageInPrint,
  setStageShowType,
  setPrintSettings,
} from "@/UDTreat/udTreatSlice"
import { useCanvasHeight } from "@/UDTreat/top/GetViewWidth"
import {
  EPrintModel,
  IPrintSettingJsonObj,
} from "@/core/app/slices/user/user.type"
import WarningAmberIcon from "@mui/icons-material/WarningAmber"
import { UButton } from "@/components/index"
import { set } from "react-hook-form"
import {
  setIsShowProgress,
  setProgressMsg,
} from "@/core/app/slices/clinical/clinicalSlice"
interface TabPanelProps {
  children?: React.ReactNode
  index: number
  value: number
}
const CustomTabPanel = (props: TabPanelProps) => {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      style={{
        visibility: value === index ? "visible" : "hidden",
        height: value === index ? "auto" : 0,
      }}
    >
      {children}
    </div>
  )
}
// max print stage number
const maxPrintNumber = 60
export const OrderStlPrint = () => {
  const { caseDetail } = useAppSelector((state: RootState) => state.caseService)
  const {
    openStlPrint,
    selectStageInPrint,
    printedStageInPrint,
    openLabelPreview,
    openUndercutPreview,
    openTrimPreview,
    openReviewPrint,
    printSettings,
  } = useAppSelector((state: RootState) => state.udTreatService)
  const dispatch = useAppDispatch()
  const [tabVal, setTabVal] = useState<number>(0)
  const [printStartTime, setPrintStartTime] = useState<number>(0)
  const [printThreadInfo, setPrintThreadInfo] = useState<{
    stagesPrintUseThread: boolean
    postSmoothUseThread: boolean
    cuttinglineUseThread: boolean
    generateItemUseFuture: boolean
  }>({
    stagesPrintUseThread: false,
    postSmoothUseThread: false,
    cuttinglineUseThread: false,
    generateItemUseFuture: false,
  })
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    if (newValue === undefined) {
      return
    }
    setTabVal(newValue)
  }
  const {
    patientData: { firstName = "", lastName = "" },
  } = useAppSelector((state: RootState) => {
    return state.patientService
  })

  const getArch = (udesign_category) => {
    let caseArch = "both",
      UpperType = "A",
      LowerType = "A"

    if (!udesign_category) return caseArch
    UpperType = udesign_category.split("/")[0]

    LowerType = udesign_category.split("/")[1]

    if (UpperType.includes("--")) {
      caseArch = "lower"
    } else if (LowerType.includes("--")) {
      caseArch = "upper"
    }

    return { caseArch, UpperType, LowerType }
  }

  const {
    firstStage: { upStageIndex: upTempIndex, lowerStageIndex: lowerTempIndex },
  } = caseManagement.getAttachmentIPRReport()

  const [jsonData, setJsonData] = useState<IPrintSettingJsonObj>(
    {} as IPrintSettingJsonObj,
  )
  const { clinicalSettings } = useAppSelector(
    (state: RootState) => state.userService,
  )
  const { CuttingLineCC, CuttingLineCP, CuttingLineOffset } = clinicalSettings
  const updateJsonData = (data: IPrintSettingJsonObj) => {
    // setJsonData(data)
    const dataName =
      printSettings.DefaultModel === EPrintModel.StandardModel
        ? "StandardModel"
        : printSettings.DefaultModel === EPrintModel.DPAModel
        ? "DpaModel"
        : "LuxcreoModel"
    const srcData =
      printSettings.DefaultModel === EPrintModel.StandardModel
        ? printSettings.StandardModel
        : printSettings.DefaultModel === EPrintModel.DPAModel
        ? printSettings.DpaModel
        : printSettings.LuxcreoModel
    const updatedSettings = {}
    updatedSettings[dataName] = { ...srcData, ...data }
    dispatch(setPrintSettings({ ...printSettings, ...updatedSettings }))
  }

  useEffect(() => {
    const initSetting = { ...clinicalSettings.PrintSetting, ...printSettings }
    console.log("init printSetting:", initSetting)
    // Initialize print settings
    dispatch(setPrintSettings(initSetting))

    // Clear setting cache when close clinical.
  }, [])

  useEffect(() => {
    console.log("printSettings????????:", printSettings)
    if (!printSettings.DefaultModel) {
      return
    }
    const settingData =
      printSettings.DefaultModel === EPrintModel.StandardModel
        ? printSettings.StandardModel
        : printSettings.DefaultModel === EPrintModel.DPAModel
        ? printSettings.DpaModel
        : printSettings.LuxcreoModel
    setExportModel(printSettings.DefaultModel)
    setJsonData(settingData)
  }, [printSettings])

  // call back after print
  const printCallBack = useCallback(() => {
    // console.log("print 回调函数启动")
    // console.log("printStartTime:", printStartTime)
    // console.log("printThreadInfo:", printThreadInfo)

    const printedStageCount =
      (printedStageInPrint?.up?.length || 0) +
      (printedStageInPrint?.low?.length || 0)
    console.log("打印的stage数量:", printedStageCount)

    // // for test: calculate total time
    // if (printStartTime > 0) {
    //   const end = performance.now()
    //   const totalTime = end - printStartTime
    //   const avgStageTime =
    //     printedStageCount > 0 ? totalTime / printedStageCount : 0
    //   console.log("总耗时:", totalTime)
    //   alert(`打印完成！\n
    //     打印的stage数量: ${printedStageCount}\n
    //     总耗时: ${totalTime.toFixed(2)} ms\n
    //   平均每个stage耗时: ${avgStageTime.toFixed(2)} ms\n
    //   stagesPrintUseThread: ${
    //     printThreadInfo.stagesPrintUseThread ? "并行" : "串行"
    //   }\n
    //   post process: ${printThreadInfo.postSmoothUseThread ? "并行" : "串行"}\n
    //   cuttingline: ${printThreadInfo.cuttinglineUseThread ? "并行" : "串行"}\n
    //   generateItem and undercut: ${
    //     printThreadInfo.generateItemUseFuture ? "并行" : "串行"
    //   }`)
    // } else {
    //   console.log("printStartTime <= 0，不显示alert")
    // }

    // hide progress
    dispatch(setIsShowProgress(false))
    // open review print window
    dispatch(setOpenReviewPrint(true))
  }, [dispatch, printedStageInPrint]) // printStartTime, printThreadInfo, 

  // Register the callback function on the window object.
  useEffect(() => {
    if (typeof window !== "undefined") {
      window.printCallBack = printCallBack
    }
    return () => {
      delete window.printCallBack
    }
  }, [printCallBack])

  // error for print callback
  const printBackError = () => {
    dispatch(setIsShowProgress(false))
    dispatch(setOpenReviewPrint(false))
  }
  const printStage = () => {
    if (
      selectStageInPrint.up.length <= 0 &&
      selectStageInPrint.low.length <= 0
    ) {
      console.error("Please select the stage to print")
      return
    }
    console.log("🚀 ~ printStage ~ selectStageInPrint:", selectStageInPrint)
    try {
      const modulePrintSelection =
        wasmModule.moduleManager.GetModulePrintSelection()

      modulePrintSelection.SetNameInfo(firstName, lastName)
      modulePrintSelection.SetCaseID(caseDetail.id.toString())

      const upStageCount = stagingManager.stageUpnNumber
      const lowerStageCount = stagingManager.stageLowNumber

      const upStartStep = stagingManager.wasmStageData.upStartStep
      const lowerStartStep = stagingManager.wasmStageData.lowStartStep

      const handleStage = (
        items: number[],
        tempIndex: number,
        stageCount: number,
        isLower: boolean,
      ) => {
        const arch = isLower ? 1 : 0
        items.forEach((item) => {
          if (item === 400) {
            modulePrintSelection.AddStage(Math.max(0, tempIndex - 1), 2, arch)
          } else if (item === 500) {
            // Retainer stage
            modulePrintSelection.AddStage(stageCount, 1, arch)
          } else {
            const startStep = isLower ? lowerStartStep : upStartStep // 如果是refinement stage，需要减去startStep，传入实际下标
            // Normal stage
            modulePrintSelection.AddStage(item - startStep, 0, arch)
          }
        })
      }

      handleStage(selectStageInPrint.up, upTempIndex, upStageCount, false)
      handleStage(selectStageInPrint.low, lowerTempIndex, lowerStageCount, true)

      const stagesPrintUseThread =
        modulePrintSelection.GetStagesPrintUseThread()
      const postSmoothUseThread = modulePrintSelection.GetPostSmoothUseThread()
      const cuttinglineUseThread =
        modulePrintSelection.GetCuttinglineUseThread()
      const generateItemUseFuture =
        modulePrintSelection.GetGenerateItemUseFuture()

      // for test print total time
      // const start = performance.now()
      // console.log("设置printStartTime:", start)
      // console.log("设置printThreadInfo:", {
      //   stagesPrintUseThread,
      //   postSmoothUseThread,
      //   cuttinglineUseThread,
      //   generateItemUseFuture,
      // })
      // setPrintStartTime(start)
      // setPrintThreadInfo({
      //   stagesPrintUseThread,
      //   postSmoothUseThread,
      //   cuttinglineUseThread,
      //   generateItemUseFuture,
      // })

      modulePrintSelection.OnPrintButtonDown("printCallBack()")
    } catch (error) {
      printBackError()
      console.error(error)
    }
  }

  const disabledStyle =
    openLabelPreview || openUndercutPreview || openTrimPreview
      ? {
          pointerEvents: "none",
          opacity: 0.7,
        }
      : {}
  // clear preview data
  useEffect(() => {
    return () => {
      dispatch(setOpenLabelPreview(false))
      dispatch(setOpenUndercutPreview(false))
      dispatch(setOpenTrimPreview(false))
      dispatch(setOpenReviewPrint(false))
      dispatch(setStageShowType("normal"))
    }
  }, [])

  // set preview canvas window height
  const canvasHeight = useCanvasHeight()
  useEffect(() => {
    try {
      if (openLabelPreview || openUndercutPreview || openTrimPreview) {
        if (openLabelPreview) {
          wasmModule.statusController.ResizePrintRendererInHeight(
            164 / canvasHeight,
          )
        }
        if (openTrimPreview) {
          wasmModule.statusController.ResizePrintRendererInHeight(
            244 / canvasHeight,
          )
        }
        if (openUndercutPreview) {
          wasmModule.statusController.ResizePrintRendererInHeight(
            412 / canvasHeight - 0.05,
          )
        }
      }
    } catch (error) {
      console.error(error)
    }
  }, [openLabelPreview, openUndercutPreview, openTrimPreview, canvasHeight])
  // select position
  const [toothPosition, setToothPosition] = useState<string>("") // Bottom /WallLingual/ Wall
  // hollow model
  const [hollowModel, setHollowModel] = useState<number>(0)
  // trim line value
  const [trimValue, setTrimValue] = useState(null) // 1: no trim machine, 2: digital dental trim machine, 3: general trim machine
  // export model
  const [exportModel, setExportModel] = useState<EPrintModel>(
    EPrintModel.StandardModel,
  ) //1: standard , 2:DPA, 3:LuxCreo
  // DPA and LuxCreo to wasm
  useEffect(() => {
    try {
      if (!wasmModule.moduleManager.GetModulePrintSelection()) return
      dispatch(clearPrintedStageInPrint())

      dispatch(setIsPrintAsDPA(exportModel === EPrintModel.DPAModel))
      if (exportModel === EPrintModel.DPAModel) {
        // if select DPA and label will go stagenumber
        if (tabVal === 1) {
          setTabVal(0)
        }
        wasmModule.moduleManager.GetModulePrintSelection().SetDPAEnable(true)
      } else {
        wasmModule.moduleManager.GetModulePrintSelection().SetDPAEnable(false)
      }
      if (exportModel === EPrintModel.LuxcreoModel) {
        // if select Luxcreo and label or others will go stagenumber
        if (tabVal === 1 || tabVal === 4) {
          setTabVal(0)
        }
        wasmModule.moduleManager
          .GetModulePrintSelection()
          .SetLuxCreoEnable(true)
      } else {
        wasmModule.moduleManager
          .GetModulePrintSelection()
          .SetLuxCreoEnable(false)
      }
    } catch (error) {
      console.error(error)
    }
  }, [exportModel])
  // stage show or hide
  useEffect(() => {
    if (
      openLabelPreview ||
      openUndercutPreview ||
      openTrimPreview ||
      openReviewPrint
    ) {
      dispatch(setStageShowType(""))
    } else {
      dispatch(setStageShowType("normal"))
    }
  }, [openLabelPreview, openUndercutPreview, openTrimPreview, openReviewPrint])

  // pass cuttingline value to wasm
  useEffect(() => {
    const printMoudle = wasmModule.moduleManager.GetModulePrintSelection()
    if (printMoudle) {
      try {
        printMoudle.SetTrimLineAnteriorType(+CuttingLineCC)
        printMoudle.SetTrimLinePosteriorType(+CuttingLineCP)
        printMoudle.SetTrimLineOffsetType(+CuttingLineOffset)
      } catch (error) {
        console.log(error)
      }
    }
  }, [wasmModule.moduleManager.GetModulePrintSelection()])

  // check label length pop-up
  const [labelWarning, setLabelWarning] = useState<boolean>(false)
  // process pop-up
  const [processWarning, setProcessWarning] = useState<boolean>(false)
  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        minHeight: "100%",
      }}
    >
      <Box sx={{ width: "100%", textAlign: "left", marginBottom: "24px" }}>
        <UText variant={"h4"}>{`Print STL Model: Settings`}</UText>
      </Box>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          marginBottom: "8px",
        }}
      >
        <UText variant={"h6"}>{`Export as`}</UText>
        <Select
          sx={{
            width: "260px",
            height: "40px",
            marginLeft: "8px",
            background: "#fff",
          }}
          displayEmpty
          value={exportModel}
          onChange={(eve) => {
            console.log("exportModel:", eve.target.value)
            setExportModel(eve.target.value)
            dispatch(setPrintSettings({ DefaultModel: eve.target.value })) // Update print settings with selected model
          }}
          disabled={openLabelPreview || openUndercutPreview || openTrimPreview}
        >
          <MenuItem
            value={EPrintModel.StandardModel}
          >{`Standard Model`}</MenuItem>
          <MenuItem
            value={EPrintModel.DPAModel}
          >{`DPA (Direct Print Aligner)`}</MenuItem>
          <MenuItem value={EPrintModel.LuxcreoModel}>{`LuxCreo`}</MenuItem>
        </Select>
      </Box>
      <Tabs
        value={tabVal}
        onChange={handleChange}
        aria-label="basic tabs example"
        sx={{
          "& .MuiTab-root": {
            padding: "9px 16px",
            fontSize: "14px",
            fontWeight: "500",
            minWidth: "unset",
            maxWidth: "unset",
            letterSpacing: "0.4px",
            textTransform: "uppercase",
          },
        }}
      >
        <Tab
          label="Stage number"
          disabled={openLabelPreview || openUndercutPreview || openTrimPreview}
        />
        <Tab
          label="Label"
          disabled={
            openLabelPreview ||
            openUndercutPreview ||
            openTrimPreview ||
            exportModel === EPrintModel.DPAModel ||
            exportModel === EPrintModel.LuxcreoModel
          }
        />
        <Tab
          label="Digital Fill"
          disabled={openLabelPreview || openUndercutPreview || openTrimPreview}
        />
        <Tab
          label="Trim"
          disabled={openLabelPreview || openUndercutPreview || openTrimPreview}
        />
        <Tab
          label="Others"
          disabled={
            openLabelPreview ||
            openUndercutPreview ||
            openTrimPreview ||
            exportModel === EPrintModel.LuxcreoModel
          }
        />
      </Tabs>

      <Box
        sx={{
          background: "#fff",
          padding: "24px",
          height: "352px",
          "& .MuiInput-root, & .MuiFormControlLabel-root, & .MuiFormControl-root":
            {
              ...disabledStyle,
            },
        }}
      >
        <CustomTabPanel value={tabVal} index={0}>
          <StageNumber jsonData={jsonData} updateJsonData={updateJsonData} />
        </CustomTabPanel>
        <CustomTabPanel value={tabVal} index={1}>
          <OrderLabel
            exportModel={exportModel}
            jsonData={jsonData}
            updateJsonData={updateJsonData}
          />
        </CustomTabPanel>
        <CustomTabPanel value={tabVal} index={2}>
          <UndercutFill jsonData={jsonData} updateJsonData={updateJsonData} />
        </CustomTabPanel>
        <CustomTabPanel value={tabVal} index={3}>
          <TrimLine
            exportModel={exportModel}
            jsonData={jsonData}
            updateJsonData={updateJsonData}
          />
        </CustomTabPanel>
        <CustomTabPanel value={tabVal} index={4}>
          <PrintOthers
            exportModel={exportModel}
            jsonData={jsonData}
            updateJsonData={updateJsonData}
          />
        </CustomTabPanel>
      </Box>

      {/* stage */}
      <SelectStage />
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Box
          sx={{
            width: "60%",
            display:
              selectStageInPrint.up.length + selectStageInPrint.low.length > 0
                ? "flex"
                : "none",
            flexDirection: "column",
          }}
        >
          <UText variant={"h6"}>
            <UText
              variant={"h6"}
              color={
                selectStageInPrint.up.length + selectStageInPrint.low.length >
                maxPrintNumber
                  ? "error.main"
                  : ""
              }
            >{`${
              selectStageInPrint.up.length + selectStageInPrint.low.length
            }`}</UText>
            {` stages selected`}
          </UText>
          {selectStageInPrint.up.length + selectStageInPrint.low.length >
            maxPrintNumber && (
            <UText
              color={"error.main"}
              variant={"h7"}
            >{`For stability, the maximum number of selected stages (upper + lower )
allowed for one time print is ${maxPrintNumber}`}</UText>
          )}
        </Box>
        <Button
          onClick={() => {
            //判断selectStageInPrint是否为空
            if (
              selectStageInPrint.up.length <= 0 &&
              selectStageInPrint.low.length <= 0
            )
              return
            // Check if the maximum print count has been exceeded.
            if (
              selectStageInPrint.up.length + selectStageInPrint.low.length >
              maxPrintNumber
            )
              return
            //check label length,if up 10 will show the pop-up
            //getLabelLength
            try {
              const labelLength = wasmModule.moduleManager
                .GetModulePrintSelection()
                .GetLabelMaxLength()
              console.log("labelLength", labelLength)
              if (labelLength > 10) {
                setLabelWarning(true)
                console.log("The length of tag can't be greater than 10!")
                return
              }
            } catch (error) {
              console.log(error)
            }

            setProcessWarning(true)
          }}
          variant="contained"
          sx={{
            padding: "6px 16px",
            width: "150px",
            height: "36px",
            marginLeft: "auto",
          }}
          disabled={openLabelPreview || openUndercutPreview || openTrimPreview}
        >{`next`}</Button>
      </Box>

      {/* check label length pop-up */}
      <Dialog open={labelWarning}>
        <DialogTitle
          sx={{ padding: "16px 24px", display: "flex", alignItems: "center" }}
        >
          <WarningAmberIcon sx={{ color: "#ED6C02", marginRight: "8px" }} />
          <Typography variant="h6" color={"rgba(0, 0, 0, 0.87)"}>
            Tag Warning
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ paddingBottom: "12px" }}>
          <Typography variant="body1" color={"rgba(0, 0, 0, 1)"}>
            The length of tag can't be greater than 10!
          </Typography>
        </DialogContent>
        <DialogActions
          sx={{
            justifyContent: "end",
            padding: "8px 14px 8px 24px",
          }}
        >
          <UButton
            onClickHandler={() => {
              setLabelWarning(false)
            }}
            variant={"contained"}
            btnText={"OK"}
          />
        </DialogActions>
      </Dialog>

      <Dialog open={processWarning}>
        <DialogTitle
          sx={{ padding: "16px 24px", display: "flex", alignItems: "center" }}
        >
          <WarningAmberIcon sx={{ color: "#D32F2F", marginRight: "8px" }} />
          <Typography variant="h6" color={"rgba(0, 0, 0, 0.87)"}>
            Preparing Your Download:
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ paddingBottom: "12px" }}>
          <Typography variant="body1" color={"rgba(0, 0, 0, 1)"}>
            Please wait while we process your files.
          </Typography>

          <Typography variant="body1" color={"rgba(0, 0, 0, 1)"}>
            This may take a few moments.
          </Typography>
        </DialogContent>
        <DialogActions
          sx={{
            justifyContent: "right",
            padding: "8px 14px 8px 24px",
          }}
        >
          <UButton
            onClickHandler={() => {
              setProcessWarning(false)
              dispatch(setIsShowProgress(true))
              dispatch(setProgressMsg("Processing... Please stand by."))
              // save select stage
              dispatch(setPrintedStageInPrint(selectStageInPrint))
              printStage()
            }}
            variant={"contained"}
            btnText={"OK"}
          />
        </DialogActions>
      </Dialog>
    </Box>
  )
}
